var _defs, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.277344 0 L 27.683594 0 L 27.683594 29 L 2.277344 29 Z M 2.277344 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M 4.585938 26.0625 L 2.269531 0.0859375 L 27.6875 0.0859375 L 25.375 26.058594 L 14.964844 28.949219 Z M 4.585938 26.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f16529",
    d: "M 23.390625 24.40625 L 25.371094 2.207031 L 14.980469 2.207031 L 14.980469 26.742188 Z M 23.390625 24.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 14.96875 5.394531 L 7 5.394531 L 7.859375 15.03125 L 14.980469 15.03125 L 14.980469 11.84375 L 10.769531 11.84375 L 10.480469 8.582031 L 14.980469 8.582031 L 14.980469 5.394531 Z M 14.980469 20.109375 L 14.964844 20.113281 L 11.421875 19.15625 L 11.199219 16.613281 L 8 16.613281 L 8.449219 21.617188 L 14.964844 23.421875 L 14.980469 23.414062 Z M 14.980469 20.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 14.96875 15.03125 L 18.886719 15.03125 L 18.527344 19.160156 L 14.976562 20.121094 L 14.976562 23.433594 L 21.503906 21.625 L 22.375 11.84375 L 14.980469 11.84375 Z M 22.863281 6.25 L 22.941406 5.394531 L 14.96875 5.394531 L 14.96875 8.582031 L 22.652344 8.582031 L 22.714844 7.863281 Z M 22.863281 6.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.06a7d6037c0ce9efb5bba53af7c217c9.svg";
export { ForwardRef as ReactComponent };